module.exports = __webpack_public_path__ + "static/media/AyudaExtranetMaveETT.9ee4f872.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AyudaExtranetMaveETT.pdf
// module id = 873
// module chunks = 0